<template>
  <li class="proposal-list-item" @click="clickHandler()">
    <proposal-card :proposal="item" />
  </li>
</template>

<script>
import proposalCard from "../../renderers/proposal-card";

export default {
  props: {
    item: {
      type: Object,
      required: true,
      default: null
    }
  },
  components: { proposalCard },
  computed: {
    isActive() {
      return this.item.id === this.$route.query.id;
    }
  },
  methods: {
    clickHandler() {
      if (this.isActive) return;
      this.$router.push({
        path: `/app/proposal?id=${this.item.id}`
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.proposal-list-item {
  position: relative;
  padding: 0 14px 0 16px;
  margin-bottom: 8px;
}
</style>
